import { z } from 'zod';
import { PartnerBillingType } from '../../enums/Partner';
import { AddressSchema } from '../../types/Address';
import { BaseSchema } from '../BaseSchema';
import { S3FileSchema } from '../S3File';
import { SubscriptionPlanSchema } from '../Subscription/SubscriptionPlan';
var BillingOptionsSchema = z.object({
    workspacesPlan: z.union([z.string().min(24).max(24), SubscriptionPlanSchema]),
    minimalCost: z.number().min(0),
    amountForFixedBilling: z.number().min(0).optional().nullable(),
    billingType: z.nativeEnum(PartnerBillingType)
});
export var PartnerSchema = BaseSchema.extend({
    logoFile: S3FileSchema.optional(),
    displayName: z.string().min(1),
    legalName: z.string().min(1),
    federalDocument: z.string().min(14).max(18),
    email: z.string().optional().refine(function (v) { return v ? z.string().email().safeParse(v).success : true; }),
    address: AddressSchema,
    billingOptions: BillingOptionsSchema.optional(),
    iuguId: z.string().optional(),
    active: z.boolean()
});
